import { faShelves } from '@fortawesome/pro-regular-svg-icons'
import { SectionWrapper } from '../SectionWrapper/SectionWrapper'
import { DetailInfo, DetailRow } from '../DetailRow/DetailRow'
import { Dimension, PrivateOffer } from '../../../modules/privateOffer/types'
import { useStyles } from './AwsAmiInstance.styles'
import { isNonEmptyNumber, numberFormat } from '@labrav/common'
import { get } from 'lodash'

type AwsAmiInstanceProps = {
  dimensions?: Dimension[]
  currencySymbol?: string
  privateOffer?: PrivateOffer
}

export const AwsAmiInstance = ({
  dimensions,
  currencySymbol = '$',
  privateOffer,
}: AwsAmiInstanceProps) => {
  const { classes } = useStyles()

  const isFlexiblePaymentTerms = privateOffer?.flexiblePaymentTerms

  const pricingModel = privateOffer?.pricingModel

  const instanceList = (dimensions || []).map((dimension, index) => {
    const usagePrice = get(dimension, 'additionalUsagePrice', null) as
      | number
      | null

    const usagePriceValue = usagePrice ?? undefined

    return (
      <DetailRow
        key={`${dimension.label || 'instance'}-${index}`}
        borderBottom={index + 1 !== (dimensions || []).length}
        children={
          <>
            <DetailInfo
              varient="small"
              value={dimension.label || '-'}
              keyName="instanceType"
              gridSize={4}
            />
            {isFlexiblePaymentTerms && (
              <DetailInfo
                keyName="quantity"
                varient="small"
                value={
                  <div className={classes.textAlignRight}>
                    {isNonEmptyNumber(dimension?.quantity as number)
                      ? String(dimension.quantity)
                      : '-'}
                  </div>
                }
                gridSize={4}
              />
            )}
            {pricingModel === 'upfront-payment' && (
              <DetailInfo
                keyName="price"
                varient="small"
                value={
                  <div className={classes.textAlignRight}>
                    <span className={classes.currency}>{currencySymbol}</span>{' '}
                    {isNonEmptyNumber(dimension?.price as number)
                      ? numberFormat(dimension.price as number, 3)
                      : '-'}
                  </div>
                }
                gridSize={4}
              />
            )}
            <DetailInfo
              keyName="usagePrice"
              varient="small"
              value={
                <div className={classes.textAlignRight}>
                  {isNonEmptyNumber(usagePriceValue) ? (
                    <>
                      <div className={classes.amount}>
                        <span className={classes.currency}>
                          {currencySymbol}
                        </span>{' '}
                        {numberFormat(usagePriceValue ?? 0, 3)}
                      </div>
                    </>
                  ) : (
                    '-'
                  )}
                </div>
              }
              gridSize={4}
            />
          </>
        }
      />
    )
  })

  return (
    <SectionWrapper
      heading={`Instance details (${dimensions?.length})`}
      icon={faShelves}
      children={
        <div className={classes.root} data-testid={'aws-ami-instance-view'}>
          <DetailRow
            borderBottom
            children={
              <>
                <DetailInfo
                  gridSize={4}
                  varient="small"
                  title="Instance type"
                />
                {isFlexiblePaymentTerms && (
                  <DetailInfo
                    gridSize={4}
                    titleClassName={classes.titleRight}
                    varient="small"
                    title="Quantity"
                  />
                )}
                {pricingModel === 'upfront-payment' && (
                  <DetailInfo
                    gridSize={4}
                    titleClassName={classes.titleRight}
                    varient="small"
                    title="Price"
                  />
                )}
                <DetailInfo
                  gridSize={4}
                  titleClassName={classes.titleRight}
                  varient="small"
                  title="Usage price/hr"
                />
              </>
            }
          />
          <div className={classes.scrollableContainer}>{instanceList}</div>
        </div>
      }
    />
  )
}
